import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { SpinnerStateService } from './spinner-state.service';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private overlayRef: OverlayRef | null = null;
  private spinnerSubscription: Subscription;

  constructor(
    private overlay: Overlay,
    private spinnerStateService: SpinnerStateService
  ) {
    this.spinnerSubscription = this.spinnerStateService.loading$
      .pipe(debounceTime(300))
      .subscribe(isLoading => {
        if (isLoading) {
          this.show();
        } else {
          this.hide();
        }
      });
  }

  private show(message = ''): void {
    // Returns an OverlayRef (which is a PortalHost)
    this.hide(); //First, hide the spinner if already showing otherwise this will result in an error.

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay
          .position()
          .global()
          .centerHorizontally()
          .centerVertically()
      });
    }

    // Create ComponentPortal that can be attached to a PortalHost
    const spinnerOverlayPortal = new ComponentPortal(SpinnerComponent);
    const componentRef = this.overlayRef.attach(spinnerOverlayPortal); // Attach ComponentPortal to PortalHost

    if (message) {
      componentRef.instance.message = message;
    }
  }

  private hide(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }
}
